import { Box } from '@mui/material';
import { Price } from 'utils/types';
import { StyledActualPrice } from './style';

interface IActualPriceProps {
  finalPrice: string;
  priceBeforeDiscount: string;
  price: Price;
  textShadow?: string;
}

export const ActualPrice: React.FC<IActualPriceProps> = ({
  finalPrice,
  priceBeforeDiscount,
  price,
  textShadow = '0px 1px 1px rgba(0, 0, 0, 0.3)',
}) => {
  return (
    <StyledActualPrice
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
      textShadow={textShadow}
    >
      {priceBeforeDiscount && (
        <Box className="stroked" gap={price.spacing ? '4px' : '0'}>
          <span>{price.currencySymbol}</span>
          <span className="actual-price">{priceBeforeDiscount}</span>
        </Box>
      )}
      {finalPrice && (
        <Box className="final-price" gap={price.spacing ? '4px' : '0'}>
          <span>{price.currencySymbol}</span>
          <span className="actual-price">{finalPrice}</span>
        </Box>
      )}
    </StyledActualPrice>
  );
};
